import { ArrowNavigation } from '#/components/ArrowNavigation/ArrowNavigation';
import { Carousel } from '#/components/Carousel/Carousel';
import { useCarouselState } from '#/components/Carousel/useCarouselState';
import { TileGridTile } from '#/components/TileGrid/Tile/TileGridTile';
import type { TileGridTileData } from '#/components/TileGrid/TileGridTileData';
import type { TileGridVariant } from '#/components/TileGrid/TileGridVariant';
import { useIsClient } from '#/hooks/useIsClient';

import {
  TileGridCarouselHolder,
  TileGridCarouselTileHolder,
} from './TileGridCarousel.styled';

type Props = {
  tiles: TileGridTileData[];
  variant: TileGridVariant;
  tilesPerRow: 3 | 4;
  onClickTile: (index: number) => void;
};

export function TileGridCarousel({
  tiles,
  variant,
  tilesPerRow,
  onClickTile,
}: Props) {
  const carouselState = useCarouselState({
    slideCount: tiles.length,
    responsiveSlidesPerPage: { xs: 1, sm: 2, md: tilesPerRow, lg: tilesPerRow },
  });
  const isClient = useIsClient();

  return (
    <TileGridCarouselHolder>
      <Carousel
        state={carouselState}
        qaId="tile-grid-carousel"
        autoHeight
        gutter={0}
        navigation={
          isClient && (
            <ArrowNavigation
              nextPage={carouselState.goToNextPage}
              prevPage={carouselState.goToPreviousPage}
              current={carouselState.currentPage}
              total={carouselState.pageCount}
              outset
            />
          )
        }
        slides={tiles.map((tile, index) => (
          <TileGridCarouselTileHolder key={tile.id}>
            <TileGridTile
              id={tile.id}
              imageData={tile.imageData}
              variant={variant}
              heading={tile.heading}
              subHeading={tile.subHeading}
              description={tile.description}
              tileHref={tile.tileHref}
              onClick={() => onClickTile(index)}
            />
          </TileGridCarouselTileHolder>
        ))}
      />
    </TileGridCarouselHolder>
  );
}
